import type { ToothDepthMapping } from '../config';

export const toothDepthMmOfRatio = ({
  depth,
  ratio,
}: {
  depth: ToothDepthMapping;
  ratio: number;
}): number => depth.crownOffsetMm + ratio * depth.spanMm;

export const toothDepthRowOfRatio = ({
  depth,
  ratio,
}: {
  depth: ToothDepthMapping;
  ratio: number;
}): number => {
  const spanBins = depth.toBin - depth.fromBin;

  return depth.isCrownFirst
    ? depth.fromBin + ratio * spanBins
    : depth.toBin - ratio * spanBins;
};

export const toothDepthRatiosBelowNeck = ({
  depth,
  fromRootRatio,
  neckRatio,
  toRootRatio,
}: {
  depth: ToothDepthMapping;
  fromRootRatio: number;
  neckRatio: number;
  toRootRatio: number;
}): number[] => {
  const spanBins = Math.abs(depth.toBin - depth.fromBin);

  if (spanBins <= 0) {
    return [];
  }

  const rootRatio = (share: number) => neckRatio + (1 - neckRatio) * share;
  const from = rootRatio(fromRootRatio);
  const to = rootRatio(toRootRatio);
  const stepCount = Math.max(1, Math.round((to - from) * spanBins));

  return Array.from(
    { length: stepCount + 1 },
    (_unused, step) => from + ((to - from) * step) / stepCount,
  );
};
